import React from 'react'
import { createTheme } from '@material-ui/core/styles'
import defaultTheme from 'env/theme'
import ButtonWidget from '../organisms/ButtonWidget'
import useInitialProps from '../../hooks/useStaticContext'

const ButtonPage = ({ staticContext }) => {
  const {
    variant = null,
    buttonColor = null,
    cardUrl = null,
    buttonText = 'Consulter l& apos; accessibilité',
  } = useInitialProps(staticContext)

  const theme = buttonColor
    ? createTheme({
        ...defaultTheme,
        palette: {
          ...defaultTheme.palette,
          primary: {
            main: `#${buttonColor}`,
          },
        },
      })
    : defaultTheme

  return (
    <ButtonWidget
      theme={theme}
      cardUrl={cardUrl}
      variant={variant}
      text={buttonText}
    />
  )
}
export default ButtonPage
